<template>
  <div class="recordPanel">
    <div class="recordPanel--btn" @click="handlerRecorder"
         :style="{padding:btnClassName==='recording'? '25px': '10px'}">
      <div class="btn" :class="btnClassName">
        <img :src="microIcon" style="width: 29px" v-show="btnClassName !=='recording'">
      </div>
    </div>
    <div class="recordPanel--right">
      <div class="time">{{ timeFormat }}</div>
      <div class="status">{{ statusStr }}</div>
    </div>
    <div class="countdown" v-show="countdownVisible">
      <div class="countdown--wrapper"></div>
      <div class="countdown--describe">
        {{ countdown }}
      </div>
      <div class="countdown--describe" style="fontSize:40px">
        <span >准备录音</span>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import Recorder from 'js-audio-recorder';
import axios from 'axios';
import microIcon from './micro.png'
import {mapActions, mapMutations, mapState} from 'vuex'
import {getAudioDuration} from "@/utils";
import {getToken} from "@/utils/api";
import {RecordEnum, RecordStr, RecordClassName} from './RecordEnum'

export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      time: 0,
      timer: null,
      recorder: {},
      startTime: 0,
      countdownVisible: false,
      countdown: 3,
      microIcon
    }
  },
  computed: {
    ...mapState('record', ['recordStatus', 'recordIndex']),
    ...mapState(['currentProgress']),
    timeFormat() {
      return dayjs(this.time).format('mm:ss:SSS').slice(0, -1)
    },
    statusStr() {
      return RecordStr[this.recordStatus] || '未开始录制'
    },
    btnClassName() {
      if (this.disabled) {
        return 'disabled'
      }
      return RecordClassName[this.recordStatus] || ''
    }
  },
  methods: {
    ...mapMutations('record', ['setRecordIndex', 'changeRecordStatus']),
    ...mapActions(['addFragmentAudio']),
    handlerRecorder() {
      if (this.disabled) return
      if (this.recordStatus === RecordEnum.RecordInit) {
        this.readyRecord()
      } else if (this.recordStatus === RecordEnum.Recording) {
        this.stopRecord()
      } else if (this.recordStatus === RecordEnum.RecordReady) {
        this.cancelCountdown()
      }
    },
    readyRecord() {
      this.changeRecordStatus(RecordEnum.RecordReady)
      this.recorder = new Recorder({
        sampleBits: 16,                 // 采样位数，支持 8 或 16，默认是16
        sampleRate: 48000,              // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
        numChannels: 2,                 // 声道，支持 1 或 2， 默认是1
        // compiling: false,(0.x版本中生效,1.x增加中)  // 是否边录边转换，默认是false
      });
      this.recorder.onprogress = (params) => {
        // console.log(params)
        this.time = params.duration * 1000
      }
      this.setCountdown()
    },
    async startRecord() {
      if (!this.recorder) return
      console.log('开始录音')
      try {
        await this.recorder.start()
        this.changeRecordStatus(RecordEnum.Recording)
      } catch (error) {
        this.changeRecordStatus(RecordEnum.RecordInit)
        this.$emit('error', error)
      }

    },
    async stopRecord() {
      this.recorder.stop()
      this.changeRecordStatus(RecordEnum.RecordEnd)
      console.log(this.recorder.getWAVBlob())
      await this.uploadFragmentAudio()
      this.resetRecorder()
    },
    resetRecorder() {
      this.recorder.destroy().then(() => {
        this.recorder = null
        this.time = 0
        this.changeRecordStatus(RecordEnum.RecordInit)
      })
    },
    async uploadFragmentAudio() {
      let formData = new FormData()
      const token = await getToken();
      formData.append('file', this.recorder.getWAVBlob())
      let res
      try {
        res = await axios.post(`/api/upload_blob`, formData, {
          headers: {
            Authorization: token,
            'Content-Type': 'multipart/form-data',
          },
          // onUploadProgress: progressEvent => {
          //   console.log(progressEvent)}
        })
      } catch (e) {
        console.error(e)
      }
      console.log(res)
      if (res.data.status == 1) {
        console.log(res.data.data)
        const {id, url} = res.data.data
        const duration = await getAudioDuration(url)
        this.addFragmentAudio({
          audioId: id,
          name: `录音${this.recordIndex}`,
          src: url,
          loop: false,
          volume: 100,
          duration: duration * 1e3,
          crop: [0, duration],
          musicVolume: 100,
          playbackRate: 1,
          fadeIn: false,
          fadeInDuration: 1e3,
          fadeOut: false,
          fadeOutDuration: 1e3,
          start: this.startTime,
        })
        this.setRecordIndex(this.recordIndex + 1)
        console.log(this.$store.state.audios)
      } else {
        this.$message.error(res.data.msg || '网络异常')
      }
    },
    setCountdown() {
      this.countdown = 3
      this.countdownVisible = true
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          this.startTime = this.currentProgress
          this.changeRecordStatus(RecordEnum.Recording)
          this.countdownVisible = false
          clearInterval( this.timer )
          this.timer = null
        }
      }, 1000)
    },
    cancelCountdown(){
      this.countdownVisible = false
      clearInterval( this.timer )
      this.timer = null
      this.changeRecordStatus(RecordEnum.RecordInit)
    }
  },
  watch: {
    recordStatus(val) {
      if (val === RecordEnum.Recording) {
        this.startRecord()
      }
    }

  }
}
</script>
<style lang="scss" scped>
.recordPanel {
  display: flex;
  padding: 0 0 10px;
  padding: 13px 26px;

  &--btn {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    cursor: pointer;
    padding: 7px;
    box-shadow: 0px -2px 12px 0px rgba(0,0,0,0.1), 0px 2px 12px 0px rgba(0,0,0,0.3);


    .btn {
      background: #3C8CFF;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .disabled {
      background: #aaaaaa;
    }

    .recordReady {
      //background: #d9001b;
      background: #3C8CFF;
    }

    .recording {
      border-radius: 10%;
    }
  }

  &--right {
    flex: 1;
    padding-left: 28px;
    color: #333333;

    .time {
      font-size: 32px;
      line-height: 45px;
      height: 45px;
      margin-top: 5px;
    }

    .status {
      font-size: 14px;
    }
  }
}

.countdown {
  position: fixed;
  top: 40%;
  left: 50%;
  transform:translate(-50%,-50%);
  font-size: 80px;
  color: #fff;
  //border: 1px solid #000;
  //border-radius: 50%;
  width: 250px;
  height: 250px;
  padding-top: 20px;
  &--wrapper{
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: #000;
    opacity: .4;
    border-radius: 50%;
    z-index: 10;
  }
  &--describe{
    position: relative;
    z-index: 11;
    text-align: center;
  }
}
</style>